module.exports = __webpack_public_path__ + "media/images/icon-subtract-fill-5eea3d849084ce60b9a6d2c54b632e44.svg";